// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React, { useState } from "react";
import check from "../assets/icons/radio_button_check.svg";
import nonCheck from "../assets/icons/RadioNonCheckedIcon.svg";
import ToggleButton from "./ToggleButton";
import PrimaryButton from "./PrimaryButton";
import { ActionBothProps } from "../types/common";

interface AdjustmentModalProps extends ActionBothProps {
  buttons?: boolean;
  thumbnail?: boolean;
}

const AdjustmentModal: React.FC<AdjustmentModalProps> = ({showPrev, showNext, buttons = true, thumbnail = false}) => {
  const [vCheck, setVCheck] = useState<boolean>(false);
  const [aCheck, setACheck] = useState<boolean>(false);
  const [sync, setSync] = useState<boolean>(false);
  const [checkthumbnail, setCheckthumbnail] = useState<boolean>(false);
  const [lip, setLip] = useState<boolean>(false);
  const [retain, setRetain] = useState<boolean>(false);
  return (
    <>
      <p className="text-[rgb(147,146,162)] text-xs font-medium tracking-tight mt-3">Video</p>
      <div className="bg-white w-full rounded-xl mt-2">
        <div onClick={() => setVCheck(!vCheck)} className="p-2 px-3 cursor-pointer flex items-center justify-between">
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Adjust visual to match <br />dubbed video?</p>
          <img className="w-4 h-4" src={vCheck ? check : nonCheck} alt="" />
        </div>
        <hr />
        <div onClick={() => setACheck(!aCheck)}  className="p-2 px-3 cursor-pointer flex items-center justify-between">
          <p className="text-[#9392A2] text-sm font-medium tracking-tight">Adjust audio to match <br /> the original video?</p>
          <img className="w-4 h-4" src={aCheck ? check : nonCheck} alt="" />
        </div>
      </div>
      <p className="text-[rgb(147,146,162)] text-xs font-medium tracking-tight mt-5">Sync</p>
      <div onClick={() => setSync(!sync)} className="bg-white w-full rounded-xl mt-2 p-2 flex items-center justify-between mb-2 cursor-pointer">
        <p className="text-neutral-900 text-sm font-medium tracking-tight">Do you need 100% sync to keep <br />context correct on each segment?</p>
        <ToggleButton isOn={sync} setIsOn={setSync} />
      </div>
      {
        thumbnail &&
        <div onClick={() => setCheckthumbnail(!checkthumbnail)} className="bg-white w-full rounded-xl mt-2 p-2 flex items-center justify-between mb-2 cursor-pointer">
          <p className="text-neutral-900 text-sm font-medium tracking-tight">Do you need AI generated <br /> thumbnail for YouTube video?</p>
          <ToggleButton isOn={checkthumbnail} setIsOn={setCheckthumbnail} />
        </div>  
      }
      <div onClick={() => setLip(!lip)} className="bg-white w-full rounded-xl mt-2 p-2 py-3 flex items-center justify-between mb-2 cursor-pointer">
        <p className="text-neutral-900 text-sm font-medium tracking-tight">Do you need lip sync?</p>
        <ToggleButton isOn={lip} setIsOn={setLip} />
      </div>
      <p className="text-[rgb(147,146,162)] text-xs font-medium tracking-tight mt-5">Background</p>
      <div onClick={() => setRetain(!retain)} className="bg-white w-full rounded-xl mt-2 p-2 py-3 flex items-center justify-between mb-2 cursor-pointer">
        <p className="text-neutral-900 text-sm font-medium tracking-tight">Retain background sounds</p>
        <ToggleButton isOn={retain} setIsOn={setRetain} />
      </div>
      {
        buttons && 
        <div className="flex items-center gap-1 mt-3">
          <PrimaryButton onClick={() => showPrev && showPrev()} className="py-2 rounded-3xl w-full" black label="Back" />
          <PrimaryButton onClick={() => showNext && showNext()} className="py-2 rounded-3xl w-full" label="Confirm" />
        </div>
      }
    </>
  );
};

export default AdjustmentModal;